<template>
  <PostBody
    v-for="post in posts"
    :key="post.title"
    :id="post.id"
    :title="post.title"
    :body="post.body"
    :date="post.date"
  />
</template>

<script>
import PostBody from "../components/PostBody.vue";
import { listPosts } from "../firestoreHelper.js";

export default {
  name: "Home",
  data() {
    return {
      posts: [],
    };
  },
  components: { PostBody },
  created() {
    listPosts().then((posts) => {
      this.posts = posts;
    });
  },
};
</script>